import React from 'react'
import { diyStyle } from '@utils'
import { getNickName } from '@common/utils/member'
import './index.scss'

import memberImg from '@img/member/member.png'

interface IProps {
  info: IDiyMemberInfoStyle;
  memberInfo: IMemberInfo;
}

const MemberInfo: React.FC<IProps> = props => {
  const { info, memberInfo } = props

  const getMemberMargin = (align: string) => {
    if (align === 'left') {
      return '0 auto 0 0'
    } else if (align === 'center') {
      return '0 auto'
    } else {
      return '0 0 0 auto'
    }
  }

  return (
    <div className='diy-member-info' style={{ flexDirection: info.direction === 'row' && info.align === 'right' ? 'row-reverse' : info.direction, textAlign: info.align, alignItems: info.direction === 'row' ? 'center' : '' }}>
      {
        !memberInfo.avatarUrl && memberInfo.nickName ? (
          <div className='diy-member-info-nickname' style={{ fontSize: `${info.nameFontSize}px`, width: `${info.avatarFontSize}px`, height: `${info.avatarFontSize}px`, margin: getMemberMargin(info.align) }}>
            <span>{memberInfo.nickName?.charAt(0)?.toUpperCase()}</span>
          </div>
        ) : (
          <div className='diy-member-info-img' style={{ backgroundImage: `url(${memberInfo.avatarUrl || memberImg})`, ...diyStyle({ width: info.avatarFontSize, height: info.avatarFontSize }), margin: getMemberMargin(info.align) }}></div>
        )
      }
      {
        info.content !== 'avatar' &&
          <div style={{ color: info.color }} className={`diy-member-info-text ${info.direction === 'row' ? 'diy-member-info-text-row' : 'diy-member-info-text-column'}`}>
            <div style={{ fontSize: `${info.nameFontSize}px`, lineHeight: `${info.nameFontSize}px` }}>{getNickName(memberInfo.nickName)}</div>
          </div>
      }
    </div>
  )
}

export default MemberInfo
